export default __webpack_public_path__ + "static/media/backIcon.1d582678.svg";